import React from "react";

export const BrandLogo = ({ className = "w-9 h-9" }) => (
    <img src="/logo.svg" alt="GeoMorphology logo" className={`${className} rounded-lg glow-orange`} data-testid="brand-logo-img" />
);
